<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Metodos de pago</ModuleHeader>
      <uv-data-table :config="config" :data="getPDVPagosTipos" :pageRows="15"
        @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Metodos de pago">
      <formMetodosPago :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </formMetodosPago>
    </modal>
  </div>


</template>



<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import ApiBioTime from "../../../clases/ApiBioTime.js";
import formMetodosPago from "./MetodosPagoForm.vue"
import axiosCore from "axios";
import { mapGetters } from "vuex";
export default {
  name: "MetodosPagoCRUD",
  components: {
    uvDataTable,
    formMetodosPago
  },
  props: ['membresia_id'],
  data() {
    return {
      TipoSDK: '',
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      showModal: false,
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Metodos de pago",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addMetodoPago",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarMetodoPago",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteMetodoPago",
            require: true,
          },
        ],
        fields: [
          {
            text: "NOMBRE",
            value: "Nombre",
          },
          {
            text: "Moneda",
            value: "Moneda",
          },
          {
            text: "Activo",
            value: "Activo",
            format: (row) => {
              let text = (row["Activo"] == true)
                ? "Activo"
                : "Inactivo";
              return text;
            },
          },
          {
            text: "Protegido",
            value: "Prtgdo",
            format: (row) => {
              let text = (row["Prtgdo"] == true)
                ? "Protegido"
                : "Editable";
              return text;
            },
          },
          {
            text: "Oculto en PDV",
            value: "opdv",
            format: (row) => {
              return (row["opdv"] === true || row["opdv"] === "true")
                ? "Oculto"
                : "Visible";
            },
          },
          {
            text: "Oculto en Comandero",
            value: "ocmd",
            format: (row) => {
              return (row["ocmd"] === true || row["ocmd"] === "true")
                ? "Oculto"
                : "Visible";
            },
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      biometricDevices: [],
      dataSDK: [],
      lastRecord: {},
    };
  },
  computed: {
    ...mapGetters(["getPDVPagosTipos", "getPDVMonedasLista"]),
  },
  methods: {

    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createMp(data);
      } else {
        this.updateMp(data)
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addMetodoPago") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        //this.$refs.modalForm.setTitle("Agregar MetodoPago");
        this.toggleModal(true);
      }
      if (buttonId == "editarMetodoPago") {
        this.idSelected = idSelected[0];
        const mp = this.$pgsHelper.getById(
          this.getPDVPagosTipos,
          "id",
          idSelected[0]
        );
        if (mp.Prtgdo) {
          this.$swal(
            "No se puede editar un metodo de pago protegido",
            "",
            "error"
          );
          return false;
        }
        this.editMode = true;
        this.editData = mp;

        this.toggleModal(true);
      }
      if (buttonId == "reportMembresia") {
        this.$router.push({ path: "/membresias/movimientos" });
      }
      if (buttonId == "deleteMetodoPago") {
        const mp = this.$pgsHelper.getById(
          this.getPDVPagosTipos,
          "id",
          idSelected[0]
        );
        if (mp.Prtgdo) {
          this.$swal(
            "No se puede editar un metodo de pago protegido",
            "",
            "error"
          );
          return false;
        }
        this.deleteMp(idSelected[0]);
      }
    },
    async getMovimientos() {
      this.data_movimentos = [];
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    createMp(data) {
      if (data.Dnrele) {
        data.Id = "CB_" + data.Id
      }
      this.$swal({
        title: "¿Deseas guardar el metodo de pago?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-MetodosPago-createMetodoPago", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            const targetId = result.value.data.id || (result.value.data.data && result.value.data.data.id) || data.Id;
            const mpName = data.Nombre || "METODO PAGO";
            this.$pgsHelper.writeLog({
              Evento: "METODO_PAGO_CREATE",
              Mensaje: `Método de pago creado: ${mpName}`.trim(),
              reference: { id: targetId, tp: "PDV-MetodoPago", al: mpName },
              data: data
            });
            this.$swal({
              title: "Guardado",
              text: "El Metodo de pago se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving metodo pago",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    updateMp(data) {
      this.$swal({
        title: "¿Deseas editar el metodo de pago?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-MetodosPago-updateMetodoPago", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            const mpName = data.Nombre || "METODO PAGO";
            this.$pgsHelper.writeLog({
              Evento: "METODO_PAGO_EDIT",
              Mensaje: `Método de pago editado: ${mpName}`.trim(),
              reference: { id: data.Id, tp: "PDV-MetodoPago", al: mpName },
              data: data
            });
            this.$swal({
              title: "Guardado",
              text: "El Metodo de pago se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving metodo pago",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteMp(id) {
      const deletedObject = this.$pgsHelper.getById(this.getPDVPagosTipos, "id", id) || { Id: id };
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar este metodo de pago?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-MetodosPago-deleteMetodoPago", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const mpName = deletedObject.Nombre || id;
            this.$pgsHelper.writeLog({
              Evento: "METODO_PAGO_DELETE",
              Mensaje: `Método de pago eliminado: ${mpName}`,
              reference: { id: id, tp: "PDV-MetodoPago", al: mpName },
              data: deletedObject
            });
            this.$swal("El metodo de pago se elimino correctamente", "", "success");
            //this.getClientes();
            this.$forceUpdate();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getTiposSdk() {
      const conf = await this.$store.getters.getFirebaseApp.database.queryBuilder("BIO/Activos");
      let resultConf = conf.val();
      this.dataSDK = this.$pgsHelper.ArrayObjectToArray(resultConf);
    },
  },
  beforeMount: function () { },
  mounted: async function () {

  },
};
</script>